import { Endpoint, Http } from "Application/Helpers/BaseEndpoint";
import { AppUrls } from "AppUrls";
import { MentorStatusEnum } from "../Enums/MentorStatusEnum";

export class GetFilteredMentorsRequest {
    keyword: string = "";
    statusType: MentorStatusEnum = MentorStatusEnum.Current;
}

export class GetFilteredMentorsResponse {
    public items: MentorListItem[] = [];
}

export class MentorListItem {
    public id: string = "";
    public firstName: string = "";
    public lastName: string = "";
    public email: string = "";
    public phone: string = "";
    public lastActionDate: Date | null = null;
    public lastActionByUserId: string = "";
    public updatedDate: Date | null = null;
    public lastActionFirstName: string = "";
    public lastActionLastName: string = "";
}

export class POST_GetFilteredMentorsEndpoint extends Endpoint<GetFilteredMentorsRequest, GetFilteredMentorsResponse> {
    constructor() {
        super();

        this.verb(Http.Post);
        this.path(AppUrls.Server.Mentor.GetFilteredMentors);
    }

    public async HandleRequestAsync(request: GetFilteredMentorsRequest): Promise<GetFilteredMentorsRequest> {
        return request;
    }

    public async HandleResponseAsync(response: GetFilteredMentorsResponse): Promise<GetFilteredMentorsResponse> {
        return response;
    }
}
